import { AliasOfflineDataFetcher } from '@skinsoft/data-store'
import { EntityDataStore } from '@skinsoft/entity-data-store';
import { TranslatedString } from '@skinsoft/i18n';
import { first } from 'rxjs/operators';

export interface Alias {
    id: string;
    translatedTitle: {
        translatedString: {
            fr: string;
            en: string;
        };
    };
    aliasSchema: {
        lastName: TranslatedString;
        firstName: TranslatedString;
    }
}

// Making aliases of types related to collaborator not to break code cohesion
// (after collaborator entity has been merged into alias entity)
export type Collaborator = Alias

export class AliasDataStore extends EntityDataStore<Alias> {
    public static getInstance() {
        if (!AliasDataStore.instance) {
            AliasDataStore.instance = new AliasDataStore();
        }

        return AliasDataStore.instance;
    }

    public static install(Vue) {
        Vue.prototype.$aliasDataStore = AliasDataStore.getInstance();
        Vue.prototype.$collaboratorDataStore = AliasDataStore.getInstance();
    }

    private static instance: AliasDataStore = null as any;

    constructor() {
        super('aliases', ['alias']);
    }


    public getCollaboratorByUserId(userId: string) {
        if (window.navigator.onLine) {
            return this.proxy.fetch(`${this.endpoint}/byUser/${userId}`)
                .pipe(first());
        } else {
            return (this.offlineDataFetcher as AliasOfflineDataFetcher).getByUser(userId)
        }
    }

    protected initializeDataFetcher() {
        this.offlineDataFetcher = new AliasOfflineDataFetcher("aliases");
    }
}


